import { renderApp } from '../index'

// not-loaded - loading - loaded

var initialModel = {
	auth_token: localStorage.auth_token,
	is_main_client: false,
	proxyPermissionLevel: 'agent',
	batches: {
		status: {
			handle: 'not-loaded',
			timestamp: null,
		},
		data: [],
	},
	uploadPhotoQueue: [],
	photos: {
		moreToLoad: true,
		status: {
			handle: 'not-loaded',
			timestamp: null,
		},
		data: [],
		erroredPhotos: [],
		quantityInBatch: 0,
	},
	me: {
		status: {
			handle: 'not-loaded',
			timestamp: null,
		},
		data: {
			clients: [],
		},
	},
	assignedViolations: {
		status: {
			handle: 'not-loaded',
			timestamp: null,
			violationsNotShown: [],
		},
		data: {
			violations: [],
			violatingImages: [],
			totalViolationNumber: 0,
		},
		selectedStage: 'agent',
	},
	violationTypes: {
		status: {
			handle: 'not-loaded',
			timestamp: null,
		},
		data: [
			{ violation_type_id: 1, violation_type_title: 'Commercial' },
			{ violation_type_id: 2, violation_type_title: 'Editorial' },
		],
	},
	whitelist: {
		status: {
			handle: 'not-loaded',
			timestamp: null,
		},
		data: [],
	},
	image_url_blacklist: {
		status: {
			handle: 'not-loaded',
			timestamp: null,
		},
		data: [],
	},
	users: {
		status: {
			handle: 'not-loaded',
			timestamp: null,
		},
		data: [],
	},
	clients: {
		status: {
			handle: 'not-loaded',
			timestamp: null,
		},
		data: [],
	},
	batchInfo: {
		status: {
			handle: 'not-loaded',
			timestamp: null,
		},
		data: [],
	},
	dropdownOpen: false,
	newViolation: {},
	csvUploadFile: null,
	csvUploadJob: null,
	csvInspectResult: null,
	passwordChanged: false,
}

var Model = {}

export const setModel = newModel => {
	Model = newModel
	return Model
}

export const getModel = () => {
	return Model
}

export const updateModel = async onUpdate => {
	Model = await onUpdate(Model)
	await renderApp()
}

export const setAuthToken = async auth_token => {
	localStorage.auth_token = auth_token
	updateModel(model => {
		model.auth_token = auth_token
		return model
	})
	await renderApp()
}

export const setInitialModel = () => {
	setModel(initialModel)
}

setInitialModel()
